import { FormControlLabel, IconButton, FormTextField } from '@patrianna/core-components'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { ChevronRight, ChevronDown } from '@patrianna-icons/material-icons'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import useReferredByCondition from 'hooks/useReferredByCondition'
import useReferredBySessionStorage from 'hooks/useReferredBySessionStorage'
import content from 'prismic-translates/auth-pages.json'

import classes from './styles.module.scss'

type Props = {
  inputClassName?: string
  initialChecked: boolean
}

const ReferredByField = ({ inputClassName, initialChecked }: Props) => {
  const [checked, setChecked] = useState(initialChecked || false)
  const { setValue, getValues } = useFormContext()
  const query = useSearchParams()
  const showField = useReferredByCondition()
  const t = getTranslationFromJson([content])
  const fieldValue = getValues('referredBy')

  const handleChange = () => {
    setChecked(!checked)
  }

  useReferredBySessionStorage()

  useEffect(() => {
    if (initialChecked) {
      setChecked(true)
    }
  }, [initialChecked])

  useEffect(() => {
    if (checked && fieldValue === '') {
      setValue('referredBy', query.get('referred_by') ?? '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked])

  if (!showField) {
    return null
  }

  return (
    <div className={classes.root}>
      <FormControlLabel
        className={classes.formControlLabel}
        labelClassName={classes.label}
        control={
          <IconButton type='button' className={classes.chevronButton} onClick={handleChange}>
            {checked ? <ChevronDown /> : <ChevronRight />}
          </IconButton>
        }
        label={<span className={classes.label}>{t('referred_by_optional')}</span>}
      />
      {checked && <FormTextField name='referredBy' className={inputClassName} />}
    </div>
  )
}

export default ReferredByField
